import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import { Button } from "@progress/kendo-react-buttons";
import { CommandCell } from '../../forms/CommandCell';
import {
    Grid,
    GridColumn as Column,
    GridToolbar,
} from "@progress/kendo-react-grid";

import './Venue.scss';

export const AdministratorVenueNames = (props) => {
    const dispatch = useDispatch();

    const editField = "inEdit";

    const [venueNames, setVenueNames] = useState([]);
    const [areVenueNamesLoading, setAreVenueNamesLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");
    
    const getVenueNames = () => {
        setAreVenueNamesLoading(true);

        const dataItem = {
            venueKey: props.venueKey,
        };
    
        fetch(`/api/administrator/venuenames`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreVenueNamesLoading(false);
                setVenueNames(result);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreVenueNamesLoading(false);
                setLoadingError(error.message);
            });
    }

    const addVenueName = (dataItem) => {
        if (!dataItem.venueKey) {
            dataItem.venueKey = props.venueKey;
        }

        fetch("/api/administrator/venuename",
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Created item successfully");

                getVenueNames();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const deleteVenueName = (venueNameKey) => {
        const dataItem = {
            "venueNameKey": venueNameKey
        }

        fetch("/api/administrator/venuename",
            {
                method: "DELETE",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                addNotificationWithTimeout(dispatch, "success", "Deleted item successfully");

                getVenueNames();
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);
            });
    }

    const addNew = () => {
        const hasNewVenueName = venueNames.some(
            (p) => p.venueNameKey === undefined
        );

        if (hasNewVenueName === true) {
            addNotificationWithTimeout(dispatch, "error", "You can only add one item at a time");
            return;
        }

        const newVenueName = {
            inEdit: true,
        };
        setVenueNames([newVenueName, ...venueNames]);
    };

    const add = (dataItem) => {
        addVenueName(dataItem);
    };

    const discard = (dataItem) => {
        const newVenueNames = [...venueNames];
        newVenueNames.splice(0, 1);
        setVenueNames(newVenueNames);
    };

    const remove = (dataItem) => {
        deleteVenueName(dataItem.venueNameKey);
    };

    const MyCommandCell = (props) => (
        <CommandCell
            {...props}
            canEdit={false}
            remove={remove}
            add={add}
            discard={discard}
            editField={editField}
            keyField="venueNameKey"
        />
    );

    const itemChange = (event) => {
        const field = event.field || "";
        const newVenueNames = venueNames.map((item) =>
            item.venueNameKey === event.dataItem.venueNameKey
                ? { ...item, [field]: event.value }
                : item
        );
        setVenueNames(newVenueNames);
    };

    useEffect(() => {
        if (props.venueKey) {
            getVenueNames();
        }
    }, []);

    return (
        <>
            {areVenueNamesLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <div>
                    <Grid
                        data={venueNames}
                        onItemChange={itemChange}
                        editField={editField}
                        dataItemKey={"venueNameKey"}
                        resizable={true}
                        scrollable="none"
                    >
                        <GridToolbar>
                            <Button
                                title={"Add New"}
                                themeColor={"primary"}
                                icon="plus"
                                onClick={addNew}
                            >
                                Add New
                            </Button>
                        </GridToolbar>
                        <Column field="name" title={"Name"} />
                        <Column cell={MyCommandCell} width="150px" />
                    </Grid>
                </div>
            ) : <div></div>)
            }
        </>
    );
}